import { useLayoutEffect, useState } from 'react'

/** How far to scale a stage `width` px wide to fill the box in `ref`, kept up to date. */
export function useStageScale(ref, width) {
  const [scale, setScale] = useState(1)

  useLayoutEffect(() => {
    const el = ref.current
    const fit = () => setScale(el.clientWidth / width)
    fit()
    const observer = new ResizeObserver(fit)
    observer.observe(el)
    return () => observer.disconnect()
  }, [ref, width])

  return scale
}
